import { useSelector } from 'react-redux';
import { AppState } from '../state/store';
import { NomenclatureBase, NomenclatureProps } from '../../../shared/src/components/NomenclatureBase';
import { CustomerNomenclature } from 'shared/src/types/CustomerNomenclature';

export function Nomenclature({ nomenclatureId }: NomenclatureProps) {
  const customerAccount = useSelector((state: AppState) => state?.currentCustomer?.customer?.customerNomenclature) as CustomerNomenclature;

  return <NomenclatureBase nomenclatureId={nomenclatureId} customer={customerAccount} />;
}
